import React from 'react';

export default function VariableInfo() {
  return (
    <div className="mb-2 p-3 bg-gray-50 rounded-md border border-gray-200 text-xs text-gray-600">
      <p className="font-medium mb-1">Available variables:</p>
      <ul className="list-disc pl-5 space-y-1">
        <li><code className="bg-gray-100 px-1 rounded">{'{'+'PET_TYPE'+'}'}</code> - Type of pet (dog, cat, etc.)</li>
        <li><code className="bg-gray-100 px-1 rounded">{'{'+'BREED'+'}'}</code> - Breed of the pet</li>
        <li><code className="bg-gray-100 px-1 rounded">{'{'+'AGE'+'}'}</code> - Age of the pet</li>
        <li><code className="bg-gray-100 px-1 rounded">{'{'+'SEX'+'}'}</code> - Sex of the pet (male, female)</li>
        <li><code className="bg-gray-100 px-1 rounded">{'{'+'ADDITIONAL_DETAILS'+'}'}</code> - Any additional details provided</li>
      </ul>
    </div>
  );
}
